import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { StateService } from '@uirouter/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Cloudinary } from 'services/cloudinary';
import { Util } from 'services/util';
import { XmStore, XmStoreUtil } from 'services/store';
import { Subscription } from 'rxjs';
import { StoreAction } from 'store/actions';
import { CmsAddonPlans } from 'store/cms/models';
import { AddonType } from 'my-account/constants';
import { AddonsUtil } from 'my-account/activity/line-detail/addon/services/addons-util';
import { RequestStatus } from 'store/request-status/models';

@Component({
    selector: 'xm-cancel-removal',
    templateUrl: 'cancel-removal.html',
    styleUrls: ['cancel-removal.scss'],
    standalone: false
})
export class XmCancelRemovalModal implements OnInit, OnDestroy {
    public dialogRef: MatDialogRef<XmCancelRemovalModal>;
    public pageData: CmsCancelOrderModal;
    public submitPromise: Promise<void | {}>;
    public stepNumber: number = 1;
    public submitClicked: boolean = false;
    public iconOptions: MediaImageOptions;
    public planData: CmsAddonPlan;
    public pendingRemovalData: CmsPendingRemoval;
    public imagePrimary: MediaImageOptions;
    public failureIcon: MediaImageOptions;
    public features: CmsPendingRemovalFeature[] = [];
    public isApiError: boolean = false;
    public isSuccess: boolean = false;

    private modalData: CancelRemovalModalData;
    private xmStore: XmStore;
    private subscriptions: Subscription[] = [];
    private state: StateService;
    private addonUtil: AddonsUtil;

    constructor(addonUtil: AddonsUtil, dialogRef: MatDialogRef<XmCancelRemovalModal>, state: StateService, xmStore: XmStore, @Inject(MAT_DIALOG_DATA) modalData: CancelRemovalModalData) {
        Object.assign(this, { addonUtil, xmStore, dialogRef, modalData, state });
    }

    public ngOnInit(): void {
        this.subscriptions.push(XmStoreUtil.subscribe(this.xmStore.peek<CmsAddonPlans>(CmsAddonPlans), (result: CmsAddonPlans) => {
            const addonType: string = this.modalData.isGtp ? AddonType.GTP : AddonType.CAN_MEX_UNL_PASS;
            this.planData = result.plans.find((plan: CmsAddonPlan) => plan.gtp1B && plan.type === addonType);
            this.pendingRemovalData = this.planData.content.pendingRemoval;
            this.pendingRemovalData.features.forEach((feature: CmsPendingRemovalFeatureData) => {
                this.features.push({
                    description: feature.description,
                    imageOption: {
                        mobile: Cloudinary.generateMediaFromCms(feature.icon)
                    }
                });
            });
            this.imagePrimary = {
                mobile: Cloudinary.generateMediaFromCms(this.pendingRemovalData.iconPrimary)
            };
            this.failureIcon = {
                mobile: Cloudinary.generateMediaFromCms(this.pendingRemovalData.failureIcon)
            };
        }));
    }

    public ngOnDestroy(): void {
        Util.unsubscribeAll(this.subscriptions);
    }

    public close(): void {
        this.dialogRef.close();
        if (this.isSuccess) {
            this.navigateAndClear();
        }
    }

    public onDoneClick(): void {
        this.dialogRef.close();
        this.navigateAndClear();
    }

    public submit(): void {
        this.submitPromise = this.addonUtil.postApis(StoreAction.CANCEL_REMOVE_ADDON, this.modalData.lineId, '', this.modalData.removalRequestCode)
            .then((requestStatus: RequestStatus) => {
                if (requestStatus.status === 'SUCCESS') {
                    this.isSuccess = true;
                } else {
                    this.isApiError = true;
                }
            })
            .catch(() => this.isApiError = true);
    }

    private navigateAndClear(): void {
        this.state.go('account.activity.landing', {}, { reload: true });
        const clearApisList: StoreDeleteAction[] = [
            { action: StoreAction.CLEAR_GLOBAL_TRAVEL_PASS }
        ];
        this.xmStore.clearApis(clearApisList);
    }
}
